var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDna(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.153,
    height: 8.506,
    viewBox: "0 0 15.153 8.506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3925",
    "data-name": "Group 3925",
    transform: "translate(1716.267 -1118.449) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16958",
    "data-name": "Path 16958",
    d: "M1119.63,1702.727a4.666,4.666,0,0,0,2.016,4.343c1.149.909,2.242,1.891,3.353,2.847a5.359,5.359,0,0,1,2,4.364c-.01.446,0,.893-.006,1.339-.005.363-.154.638-.55.646s-.542-.276-.548-.637c-.007-.414-.019-.83,0-1.243a4.34,4.34,0,0,0-1.642-3.654c-1.178-1-2.344-2.017-3.536-3a5.491,5.491,0,0,1-2.191-4.611c.016-.462,0-.925.008-1.387.009-.367.177-.625.574-.618.378.006.52.26.523.609S1119.63,1702.392,1119.63,1702.727Z",
    transform: "translate(-0.064 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16959",
    "data-name": "Path 16959",
    d: "M1170.881,1702.832c.221,2.418-1,4.088-2.819,5.454-.469.353-.649-.131-.892-.337-.3-.251.042-.374.183-.5a10.123,10.123,0,0,0,1.723-1.708,4.122,4.122,0,0,0,.7-2.293c.007-.557,0-1.114,0-1.671,0-.367.154-.637.552-.635s.54.284.547.644S1170.881,1702.482,1170.881,1702.832Z",
    transform: "translate(-43.951 -0.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16960",
    "data-name": "Path 16960",
    d: "M1121.539,1784.221a1.421,1.421,0,0,1,.7.567c.147.233-.14.314-.264.431a10.494,10.494,0,0,0-1.694,1.677,4.173,4.173,0,0,0-.717,2.388c0,.526.006,1.052-.01,1.578a.512.512,0,0,1-.532.556.5.5,0,0,1-.543-.5c-.076-1.666-.122-3.326.961-4.766a10.955,10.955,0,0,1,1.893-1.815A1.468,1.468,0,0,1,1121.539,1784.221Z",
    transform: "translate(0 -75.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16961",
    "data-name": "Path 16961",
    d: "M1144.439,1709.984c.478,0,.955.01,1.432,0,.406-.012.52.2.516.564,0,.343-.1.547-.486.544q-1.456-.012-2.913,0c-.38,0-.491-.19-.493-.538,0-.364.1-.581.51-.57C1143.484,1709.994,1143.961,1709.984,1144.439,1709.984Z",
    transform: "translate(-21.744 -8.018)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16962",
    "data-name": "Path 16962",
    d: "M1144.4,1840.087c-.462,0-.924-.011-1.385,0-.409.012-.515-.2-.513-.568,0-.345.106-.544.489-.541q1.456.012,2.913,0c.384,0,.486.2.488.542,0,.365-.1.579-.513.568C1145.384,1840.076,1144.891,1840.087,1144.4,1840.087Z",
    transform: "translate(-21.748 -124.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16963",
    "data-name": "Path 16963",
    d: "M1144.632,1735.046c.476,0,.953-.01,1.429,0s.615.295.369.695a.8.8,0,0,1-.713.4c-.73,0-1.46,0-2.191,0a.787.787,0,0,1-.6-.242.61.61,0,0,1-.206-.644c.091-.243.328-.214.532-.216C1143.711,1735.042,1144.171,1735.045,1144.632,1735.046Z",
    transform: "translate(-21.918 -30.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16964",
    "data-name": "Path 16964",
    d: "M1144.572,1815.093c-.46,0-.921,0-1.381,0-.191,0-.4,0-.485-.217a.556.556,0,0,1,.119-.535.725.725,0,0,1,.6-.341q1.191-.011,2.381,0a.707.707,0,0,1,.563.316.556.556,0,0,1,.129.575c-.1.213-.306.2-.5.2C1145.525,1815.1,1145.049,1815.093,1144.572,1815.093Z",
    transform: "translate(-21.908 -102.077)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDna);
export default __webpack_public_path__ + "static/media/dna.64d5059b9942e93d5fa9081271f7f7c5.svg";
export { ForwardRef as ReactComponent };